import React, { useState } from 'react';

import ic_error from "assets/images/ic_error_message.svg";
// import ic_warning from "assets/images/ic_warning_message.svg";
import ic_success from "assets/images/ic_success_message.svg";
import ic_small_close_inverse from "assets/images/ic_small_close_inverse.svg";

import "assets/scss/components/notification/alertMessage.scss";
import { func_validation } from 'functions';
import { useEffect } from 'react';



export function AlertMessage(props) {
    const { 
        className, wrapperclassName,
        alertType, 
        headerMsg, message: message_props, 
        isVisible, isAlertTypeIconHidden, isCloseIconHidden
    } = props;

    // Validate props
    let alertType_lowercase = "";
    if (func_validation.isStringTrimNotEmpty(alertType)) {
        alertType_lowercase = alertType.toLowerCase();
    }

    // States
    const [message, setMessage] = useState();

    let alertTypeIconSrc = ic_error;
    let alertTypeIconAlt = "Exclamation Mark";
    let headerMsg_default = "Error";
    let alertColorClassName = "component-alertMessage_errorColor";
    switch(alertType_lowercase) {
        case "warning":
            // alertTypeIconSrc = ic_warning;
            alertTypeIconAlt = "Warning Icon";
            headerMsg_default = "Warning";
            alertColorClassName = "component-alertMessage_warningColor";
            break;
        case "success":
            alertTypeIconSrc = ic_success;
            alertTypeIconAlt = "Check Icon";
            headerMsg_default = "Success";
            alertColorClassName = "component-alertMessage_successColor";
            break;
        default:
            break;
    }
    let headerMsg_validated = func_validation.isStringTrimNotEmpty(headerMsg)? headerMsg: headerMsg_default;

    function toggleVisibility() {
        if (func_validation.isFunction(props.toggleVisibility))
            props.toggleVisibility();
    }

    function updateMessage(msg) {
        if (func_validation.isNotNullUndefined(msg)) {
            let msg_validated = func_validation.isNotNullUndefined(msg)? msg: "";
            setMessage(msg_validated);
        }
        else setMessage("");
    }
    useEffect(() => {
        updateMessage(message_props);
    }, [message_props]);

    
    if ((message == "") || (!isVisible)) return "";

    return (
        <div className={"component-alertMessage " +
                (className? className + " ":"")}
        >
            <div className={"component-alertMessageWrapper d-flex align-items-center justify-content-between " +
                    (wrapperclassName? wrapperclassName + " ":"") +
                    (alertColorClassName? alertColorClassName + " ":"")}
            >
                <div className={"component-alertMessage-msgWrapper d-flex align-items-center "}>
                    {/* Alert Type Icon */}
                    {(!isAlertTypeIconHidden)? (
                        <div className="component-alertMessage-alertTypeIcon align-self-start">
                            <img
                                src={alertTypeIconSrc}
                                alt={alertTypeIconAlt}
                            />
                        </div>
                    ):""}

                    {/* Message */}
                    <div className="component-alertMessage-message">
                        <div className="component-alertMessage-message-title">{headerMsg_validated}:</div>
                        <div className={"component-alertMessage-message-text "}
                        >
                            {message}
                        </div>
                    </div>
                </div>

                {/* Close Icon */}
                {(!isCloseIconHidden)? (
                    <div className="component-alertMessage-closeIconWrapper d-flex align-items-start"
                        onClick={toggleVisibility}
                    >
                        <img 
                            className={"component-alertMessage-closeIcon"}
                            src={ic_small_close_inverse}
                            alt={"Close button"}
                        />
                    </div>
                ):""}
            </div>
        </div>
    );
}